<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Online">
    <app-radiobremen-online-bericht [onlineVorhersageBericht]="radioBremenBericht?.online"></app-radiobremen-online-bericht>
  </mat-tab>
  <mat-tab label="Videotext">
    <app-radiobremen-videotext-bericht [videotextVorhersageBericht]="radioBremenBericht?.videotext"></app-radiobremen-videotext-bericht>
  </mat-tab>
  <mat-tab label="Spezialwetter">
    <app-radiobremen-spezial-bericht [spezialBericht]="radioBremenBericht?.online?.spezialwetter"></app-radiobremen-spezial-bericht>
  </mat-tab>
  <mat-tab label="Ozon">
    <app-radiobremen-ozon-bericht [ozonBericht]="radioBremenBericht?.ozon"></app-radiobremen-ozon-bericht>
  </mat-tab>
</mat-tab-group>
